"use client";

import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { useMountEffect } from "@opensea/ui-kit/hooks";
import { captureException } from "@sentry/nextjs";
import { useState } from "react";
import { readEventId } from "@/lib/error";
import { extractPath, extractTraceId } from "@/lib/graphql";
export const useCaptureErrorOnMount = t0 => {
  const $ = _c(15);
  const {
    error,
    tags,
    amplitudeEventName
  } = t0;
  const [errorId, setErrorId] = useState(null);
  let t1;
  if ($[0] !== error) {
    t1 = extractTraceId(error);
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const traceId = t1;
  let t2;
  if ($[2] !== error) {
    t2 = extractPath(error);
    $[2] = error;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== traceId) {
    t3 = {
      "x-trace-id": traceId,
      "graphql.path": t2
    };
    $[4] = t2;
    $[5] = traceId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const gqlDebug = t3;
  let t4;
  if ($[7] !== amplitudeEventName || $[8] !== error || $[9] !== gqlDebug || $[10] !== tags) {
    t4 = () => {
      console.error(error);
      if (amplitudeEventName) {
        track(amplitudeEventName, {
          error: error.message,
          ...gqlDebug
        });
      }
      const errorId_0 = readEventId(error);
      if (errorId_0) {
        setErrorId(errorId_0);
        return;
      }
      const timeout = setTimeout(() => {
        const errorId_1 = readEventId(error) || captureException(error, {
          tags: {
            ...gqlDebug,
            ...tags
          }
        });
        setErrorId(errorId_1);
      }, 1000);
      return () => {
        clearTimeout(timeout);
      };
    };
    $[7] = amplitudeEventName;
    $[8] = error;
    $[9] = gqlDebug;
    $[10] = tags;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useMountEffect(t4);
  let t5;
  if ($[12] !== errorId || $[13] !== traceId) {
    t5 = {
      errorId,
      traceId
    };
    $[12] = errorId;
    $[13] = traceId;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};